<template>
  <div class="ws-modal">
    <form
      class="ws-modal__form"
      @submit.prevent="submit"
    >
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-text="$t('Формирование отчета')"></span>
        </h2>
        <p class="reports-f-hint is-size-3 has-text-weight-bold">{{$t('Обратите внимание, отчеты с количеством выгружаемых строк более 10 000 будут выгружены частично.')}}</p>
      </header>
      <div
        class="ws-modal__content"
        :class="{'is-loading':isPending}"
      >
        <div class="columns is-multiline">
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Тип экзамена')"
              :type="{'is-danger': errors.has('type')}"
              :message="errors.first('type')"
            >
              <b-select
                class="ws-field__control"
                name="type"
                :placeholder="$t('')"
                v-model="flags"
                @input="selectType"
                :disabled="types.length <= 1"
                expanded
              >
                <option
                  v-for="t of types"
                  :key="t.value"
                  :value="t.value"
                  v-text="t.title"
                ></option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-half">
            <ws-permission-node
              :resources="['resources/region']"
              @permissions="setRegionPermission"
            >
              <b-field
                class="ws-field"
                :label="$t('Регион')"
                :type="{'is-danger': errors.has('region')}"
                :message="errors.first('region')"
              >
                <ws-refbook-field
                  name="region"
                  entity="public/refbook/region"
                  field="title.display"
                  v-model="region_guid.value"
                  :guid.sync="region_guid.guid"
                  :disabled="region_guid.isDisabled"
                  :params="{country: config.default_country_code}"
                  @change="selectRegion"
                  :isFocus="true"
                >
                  <template
                    slot="empty"
                    v-text="$t('Ничего не найдено')"
                  ></template>
                </ws-refbook-field>
              </b-field>
            </ws-permission-node>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Профессия/специальность (ДЭ)')"
              :type="{'is-danger': errors.has('competence')}"
              :message="errors.first('competence')"
            >
              <ws-refbook-field
                name="competence"
                entity="competence"
                field="name.display"
                v-model="competency_guid.value"
                :guid.sync="competency_guid.guid"
                :disabled="competency_guid.isDisabled"
                @change="selectCompetence"
                :isFocus="true"
              >
                <template
                  slot="empty"
                  v-text="$t('Ничего не найдено')"
                ></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('ЦПДЭ')"
              :type="{'is-danger': errors.has('deCenter')}"
              :message="errors.first('deCenter')"
            >
              <ws-refbook-field
                name="deCenter"
                entity="de-centers"
                field="name.display"
                v-model="de_center_guid.value"
                :guid.sync="de_center_guid.guid"
                @change="selectDeCenter"
                :isFocus="true"
              >
                <template
                  slot="empty"
                  v-text="$t('Ничего не найдено')"
                ></template>
                <template
                  slot="item"
                  slot-scope="props"
                >
                  <p>{{ props.option.name.display }}</p>
                  <small class="has-text-grey">{{ props.option.address.region.title.display }},
                    {{ props.option.address.locality.title.display }},
                    {{ props.option.address.address.display }}
                  </small>
                </template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата проведения ПД (начало)')"
              :type="{'is-danger': errors.has('day_cm1_start')}"
              :message="errors.first('day_cm1_start')"
            >
              <ws-datepicker
                v-model="day_cm1.from"
                v-validate="'correctDate'"
                :data-vv-as="$t('Дата проведения ПД (начало)')"
                name="day_cm1_start"
              >
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата проведения ПД (конец)')"
              :type="{'is-danger': errors.has('day_cm1_end')}"
              :message="errors.first('day_cm1_end')"
            >
              <ws-datepicker
                v-validate="'correctDate'"
                v-model="day_cm1.till"
                :data-vv-as="$t('Дата проведения ПД (конец)')"
                name="day_cm1_end"
              >
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата начала проведения ДЭ (начало)')"
              :type="{'is-danger': errors.has('start_date_from')}"
              :message="errors.first('start_date_from')"
            >
              <ws-datepicker
                v-validate="'correctDate'"
                v-model="started_at.from"
                :data-vv-as="$t('Дата начала проведения ДЭ (начало)')"
                name="start_date_from"
              >
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата начала проведения ДЭ (конец)')"
              :type="{'is-danger': errors.has('start_date_till')}"
              :message="errors.first('start_date_till')"
            >
              <ws-datepicker
                v-validate="'correctDate'"
                v-model="started_at.till"
                :data-vv-as="$t('Дата начала проведения ДЭ (конец)')"
                name="start_date_till"
              >
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата окончания проведения ДЭ (начало)')"
              :type="{'is-danger': errors.has('ended_at_from')}"
              :message="errors.first('ended_at_from')"
            >
              <ws-datepicker
                v-validate="'correctDate'"
                v-model="ended_at.from"
                :data-vv-as="$t('Дата окончания проведения ДЭ (начало)')"
                name="ended_at_from"
              >
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field
              class="ws-field"
              :label="$t('Дата окончания проведения ДЭ (конец)')"
              :type="{'is-danger': errors.has('ended_at_till')}"
              :message="errors.first('ended_at_till')"
            >
              <ws-datepicker
                v-validate="'correctDate'"
                v-model="ended_at.till"
                :data-vv-as="$t('Дата окончания проведения ДЭ (конец)')"
                name="ended_at_till"
              >
              </ws-datepicker>
            </b-field>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button
                class="ws-button button is-large is-primary is-fullwidth"
                :class="{'is-loading':isPending}"
              >
                <span
                  class="is-size-4 has-text-weight-bold"
                  v-text="$t('Сформировать отчет')"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button
        class="ws-button button is-text"
        @click="close"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import WsDatepicker from '@/components/common/WsDatepicker'
import { constants } from '@/services/constants.service'
import saveAs from 'file-saver'
export default {
  name: 'WsReportsForm',
  components: { WsDatepicker },
  data () {
    return {
      config: __config,
      constants,
      region_guid: {
        value: '',
        guid: null,
        list: [],
        isDisabled: false
      },
      competency_guid: {
        value: '',
        guid: null,
        list: [],
        isDisabled: false
      },
      de_center_guid: {
        value: '',
        guid: null,
        list: []
      },
      flags: '',
      types: [],
      day_cm1: {
        from: new Date(new Date().getFullYear(), 0, 1),
        till: new Date(new Date().getFullYear(), 11, 31)
      },
      started_at: {
        from: null,
        till: null
      },
      ended_at: {
        from: null,
        till: null
      },
      newItem: {
      }
    }
  },
  computed: {
    ...mapState('authentication', ['resourcesPermissions', 'currentRole']),
    ...mapState('public/refbook/region', {
      isRegionPending: 'isFindPending'
    }),
    ...mapState('de-centers', {
      isDeCenterPending: 'isFindPending'
    }),
    ...mapState('competence', {
      isCompetencePending: 'isFindPending'
    }),
    ...mapState('report/exams', {
      isPending: 'isCreatePending'
    })
  },
  methods: {
    ...mapActions('public/refbook/region', {
      findRegion: 'find',
      getRegion: 'getRegion'
    }),
    ...mapActions('de-centers', {
      findDeCenter: 'find'
    }),
    ...mapActions('competence', {
      findCompetence: 'find',
      getCompetency: 'getCompetency'
    }),
    ...mapActions('report/exams', {
      getReport: 'getReport'
    }),
    setRegionPermission (permission) {
      if (permission && permission.value) {
        this.region_guid.isDisabled = true
      }
    },
    selectType (type) {
      this.newItem.flags = type || ''
    },
    selectRegion (region) {
      this.region_guid.guid = region && region.guid ? region.guid : ''
      this.newItem.region_guid = region && region.guid ? region.guid : ''
    },
    selectCompetence (competence) {
      this.competency_guid.guid = competence && competence.guid ? competence.guid : ''
      this.newItem.competency_guid = competence && competence.guid ? competence.guid : ''
    },
    selectDeCenter (deCenter) {
      this.de_center_guid.guid = deCenter && deCenter.guid ? deCenter.guid : ''
      this.newItem.de_center_guid = deCenter && deCenter.guid ? deCenter.guid : ''
    },
    normalizeDates (key, value) {
      const o = {}
      const from = moment(value.from)
      const till = moment(value.till)
      o[key + '.from'] = from.isValid() ? from.format('YYYY-MM-DD') : ''
      o[key + '.till'] = till.isValid() ? till.format('YYYY-MM-DD') : ''
      return o
    },
    async submit () {
      this.$validator.resume()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const data = {
            ...this.newItem,
            ...this.normalizeDates('day_cm1', this.day_cm1),
            ...this.normalizeDates('started_at', this.started_at),
            ...this.normalizeDates('ended_at', this.ended_at)
          }
          saveAs(await this.getReport(data), 'report.xlsx')
          this.close()
          this.$buefy.toast.open({
            message: this.$t(`Отчет успешно создан`),
            type: 'is-success'
          })
        }
      })
    },
    async getCompetencyByRole () {
      if (this.currentRole === 'front_mc' && this.resourcesPermissions.competency) {
        try {
          const competency = await this.getCompetency({
            params: {
              competence: this.resourcesPermissions.competency[0]
            }
          })
          this.competency_guid.guid = competency.guid
          this.competency_guid.value = competency.name.translate.ru
          this.competency_guid.isDisabled = true
        } catch (e) {
        }
      }
    },
    close () {
      this.$parent.close()
    }
  },
  async mounted () {
    switch (this.currentRole) {
      case 'front_rcc':
        this.types = [
          {
            title: 'РО',
            value: constants.exam_flags.REGIONAL
          }
        ]
        this.flags = constants.exam_flags.REGIONAL
        this.newItem.flags = constants.exam_flags.REGIONAL
        break
      case 'front_dep':
        this.types = [
          {
            title: 'Все',
            value: `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
          },
          {
            title: 'РО',
            value: constants.exam_flags.REGIONAL
          },
          {
            title: 'Университет',
            value: constants.exam_flags.VUZ
          }
        ]
        this.flags = `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
        this.newItem.flags = `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
        break
      case 'front_admin':
        this.types = [
          {
            title: 'Все',
            value: `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
          },
          {
            title: 'РО',
            value: constants.exam_flags.REGIONAL
          },
          {
            title: 'Университет',
            value: constants.exam_flags.VUZ
          }
        ]
        this.flags = `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
        this.newItem.flags = `${constants.exam_flags.REGIONAL},${constants.exam_flags.VUZ}`
        break
    }
    this.$validator.pause()
    if (this.resourcesPermissions.region) {
      const regionGuid = this.resourcesPermissions.region.find(r => constants.ALL.indexOf(r) === -1)
      let region
      if (regionGuid) {
        try {
          region = await this.getRegion({
            params: {
              country: __config.default_country_code,
              region: regionGuid
            }
          })
        } catch (e) {
        }
      }
      if (region) {
        this.region_guid.guid = region.guid
        this.region_guid.value = region.title.translate.ru
        this.newItem.region_guid = region.guid
      }
    }
  },
  async beforeMount () {
    await this.getCompetencyByRole()
  }
}
</script>
<style scoped>
.reports-f-hint {
  margin-top: 2rem;
}
</style>
